export default __webpack_public_path__ + "static/media/qr.02038024.svg";